import '../styles/home.css';
import React from "react";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <div className="routes-ji">
      <Helmet>
        <title>GAUSH</title>
      </Helmet>

      <img className="green-shade" src="/images/green-shade.webp"></img>
      <section className="hero-section">
        <div className="home">
            <div className="hero-text">
                <hr/>
                <p className="m-0">
                    <span style={{color:'#FFE400'}}>GAUSH </span>is a 23 year old hip hop artist from the city of <span style={{color: '#FFE400'}}>Navi Mumbai</span>. He's always had a passion for music since childhood and he has grown into a musician himself over the years. He has a <span style={{color: '#FFE400'}}>versatile</span> catalogue consisting of chopper, lo-fi, RnB, story-telling, trap, drill tracks and much more.
                </p>
                <div className="social-icons">
                    <a href="https://www.instagram.com/gaushmusic" target="_blank"><img src="/images/instagram.png"/></a>
                    <a href="https://open.spotify.com/artist/5UPhqOBfNq83B0vOaLocFM" target="_blank"><img
                            src="/images/spotify.png"/></a>
                    <a href="https://www.youtube.com/channel/UCt6fAQKhWqaUESK86mjrOLw" target="_blank"><img
                            src="/images/youtube.png"/></a>
                    <a href="https://music.apple.com/us/artist/gaush/1537261706" target="_blank"><img
                            src="/images/apple-music.png"/></a>
                    <a href="https://www.jiosaavn.com/artist/gaush/6eYuRpJifqI_" target="_blank"><img
                            src="/images/jio-saavn.png"/></a>
                </div>
            </div>
            <div className="hero-img">
                <img src="images/gaush.webp"/>
            </div>
        </div>
    </section>

    <section className="featured-vid">
        <div className="vid-top">
            <div className="left">
                <p className="sub-head">FEATURED VIDEO</p>
                <p className="head">BLEW UP</p>
            </div>
            <div className="right">
                 <NavLink to="/videos" style={{textDecoration: 'none'}}>
                <p style={{fontSize: '22px', color: '#FFFFFF', display: 'inline'}}>ALL VIDEOS</p>
                <div className="icon">
                    <svg width="40" height="46" viewBox="0 0 48 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_301_124)">
                            <path
                                d="M26.1683 29.9242L32.3465 24.4799C32.7822 24.096 33 23.6074 33 23.0141C33 22.4209 32.7822 21.9323 32.3465 21.5484L26.1089 16.0518C25.6733 15.6679 25.1291 15.4843 24.4764 15.5011C23.8222 15.5192 23.2772 15.7202 22.8416 16.1041C22.4059 16.488 22.1881 16.9766 22.1881 17.5699C22.1881 18.1632 22.4059 18.6517 22.8416 19.0356L24.9802 20.9202H17.3168C16.6436 20.9202 16.0891 21.1205 15.6535 21.5211C15.2178 21.9232 15 22.4209 15 23.0141C15 23.6074 15.2281 24.1044 15.6844 24.505C16.139 24.9071 16.703 25.1081 17.3762 25.1081H24.9802L22.7822 27.045C22.3465 27.4289 22.1382 27.9091 22.1572 28.4856C22.1778 29.0608 22.4059 29.5403 22.8416 29.9242C23.2772 30.3081 23.8317 30.5 24.5049 30.5C25.1782 30.5 25.7327 30.3081 26.1683 29.9242Z"
                                fill="white" />
                            <path
                                d="M26.1683 29.9242L32.3465 24.4799C32.7822 24.096 33 23.6074 33 23.0141C33 22.4209 32.7822 21.9323 32.3465 21.5484L26.1089 16.0518C25.6733 15.6679 25.1291 15.4843 24.4764 15.5011C23.8222 15.5192 23.2772 15.7202 22.8416 16.1041C22.4059 16.488 22.1881 16.9766 22.1881 17.5699C22.1881 18.1632 22.4059 18.6517 22.8416 19.0356L24.9802 20.9202H17.3168C16.6436 20.9202 16.0891 21.1205 15.6535 21.5211C15.2178 21.9232 15 22.4209 15 23.0141C15 23.6074 15.2281 24.1044 15.6844 24.505C16.139 24.9071 16.703 25.1081 17.3762 25.1081H24.9802L22.7822 27.045C22.3465 27.4289 22.1382 27.9091 22.1572 28.4856C22.1778 29.0608 22.4059 29.5403 22.8416 29.9242C23.2772 30.3081 23.8317 30.5 24.5049 30.5C25.1782 30.5 25.7327 30.3081 26.1683 29.9242Z"
                                fill="white" />
                        </g>
                        <defs>
                            <filter id="filter0_d_301_124" x="0" y="0.5" width="48" height="45"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset />
                                <feGaussianBlur stdDeviation="7.5" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_301_124" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_301_124"
                                    result="shape" />
                            </filter>
                        </defs>
                    </svg>
                </div>
            </NavLink>
            </div>
        </div>
        <div className="vid-bottom">
            <a href="https://www.youtube.com/watch?v=InpKfKmxerc" target="_blank"><img src="/images/youtube-link.png"/></a>
        </div>
    </section>

    <section className="featured-music">
        <p style={{fontSize: '55px', color: '#FFFFFF', lineHeight: '90%', marginBottom: '50px'}}>FEATURED MUSIC</p>
        <div className="music-frames">
            <a href="https://open.spotify.com/track/3QP9yuBbDgy9tmTeG6aIaz" target="_blank"><img
                src="/images/music/blewup.webp" style={{pointerEvents: 'none'}}/></a>
            <a href="https://open.spotify.com/track/7ljpQ6YCt1Mqzt85RNuiab" target="_blank"><img
                src="/images/music/ohmygaush.webp" style={{pointerEvents: 'none'}}/></a>
            <a href="https://open.spotify.com/track/0uARnIZRkbBJ69edvIjhMu" target="_blank"><img
                src="/images/music/legendary.webp" style={{pointerEvents: 'none'}}/></a>
            <a href="https://open.spotify.com/track/5KMbelIhlPgZZzd2WhObgE" target="_blank"><img
                src="/images/music/iswear.webp" style={{pointerEvents: 'none'}}/></a>
        </div>
        <NavLink className="discography-btn" to="/music"><img src="/images/view-all-discography.png"/></NavLink>
    </section>
      
    </div>
  );
};

export default Home;
